import SliderBar from './SliderBar'

export default SliderBar
// eslint-disable-next-line import/export
export * from './SliderBar'
